<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="participantGroups"
    item-value="id"
    :item-text="item => (item.header ? item.header : item.name)"
    clearable
    multiple
    return-object
  >
    <template v-slot:selection="data"> {{ data.item.name }} <br /> </template>
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ParticipantGroupsField",
  props: {
    value: Array,
    status: { type: String, required: false }
  },
  data: () => ({
    participantGroups: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    async loadParticipantGroups() {
      try {
        const filters = { isEffective: this.status };

        const { data } = await ApiService.post(
          "/api/participantGroups/search?size=500&sort=category,ASC&sort=name,ASC",
          filters
        );

        const participantGroups = (data.content || []).filter(pg => pg && pg.name && pg.name.trim() !== "");

        if (!participantGroups.length) {
          this.participantGroups = [{ header: "No category" }];
          return;
        }

        const grouped = [];
        let lastCategory = null;

        participantGroups.forEach(pg => {
          const category = pg.category || "No category";

          if (category !== lastCategory) {
            grouped.push({ header: category });
            lastCategory = category;
          }

          grouped.push(pg);
        });

        this.participantGroups = grouped;
      } catch (error) {
        console.error("Failed to load participant groups", error);
        this.participantGroups = [{ header: "No category" }];
      }
    }
  },
  mounted() {
    this.loadParticipantGroups();
  }
};
</script>
